import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class VersionService {
    private http = inject(HttpClient);

    public getVersion(): Observable<{ version: string }> {
        return this.http.get<{ version: string }>('/api/Version');
    }
}
